import React from "react";

import { Button, Col, FormLabel, Row } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { BaseBean } from "../ds/client_ds";
import {
  FabricStyleBean,
  FabricStyleSearchCriteria,
  FabricStyleWebExportInputBean,
  PageListBean,
  RestFabricStyleListBeanRequest,
  RestFabricStyleListRequest,
  RestReadRequest,
  RestSimpleItemBeanRequest,
} from "../ds/ds.js";
import { DeleteIcon } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  CollapseComponent,
  DataGridColumnDefinition,
  EditableDataGrid,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler";
import { PopupFabricStyleModule } from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { ECommerceConnectorService } from "../services/ECommerceConnectorService.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { ReportService } from "../services/ReportService.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
} from "./BaseModule.js";

class WebItemExport extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Web Item Export",
      isShowClearErrorButton: false,
      isShowToolBarButton: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isShowExitButton: true,
      isShowExecuteButton: false,
      isShowClearCriteriaButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowFabricModule: false,
      moduleForPopup: [],
      error_list: [],
      fabricStyleDataList: [],
      selectedRowDataList: [],
      isFabricStyleDataFound: false,
      fabricCriteriaList: [],
      isShowSelectAllButton: false,
      isShowUnSelectAllButton: false,
      isShowWebExportButton: false,
      isShowExportAsItemBUutton: false,
      isCollapsible_open: true,
      summaryData: null,
      criteria: new FabricStyleSearchCriteria(),
      fabricPageListForAutoCompleteList: new Array(),
      criteriaViewShow: false,
      pageList: new PageListBean(),
      isShowPageListToolBar: false,
      isShowAlert: false,
      alertMsg: "",
      success_list: [],
      fabricStyleData: new FabricStyleBean(),
      isShowAutoCompleteList: true,
      showAutoCompletePatternTypeList: true,
      showAutoCompleteProductTypeList: true,
      showAutoCompleteProductDivisionList: true,
      isShowFabricStyleModule: false,
      fileName: "",
      isShowWebExportPopup: false,
      webExportItems: [],
      targetWebsites: [],
      selectedTargetWebsites: [],
      ItemCodes: [],
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      patternTypes: [],
      productTypes: [],
      productDivisions: [],
      isCriteriaFieldDisabled: false,
      isShowFabricAutoCompleteList: false,
      is3PL: false,
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    const { cache } = appData;
    this.cache = cache;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    if (this.state.is3PL === true) {
      this.state.pageTitle = "Item SKU Detail Inquiry";
    } else {
      this.state.pageTitle = "Fabric style SKU Detail Inquiry";
    }
    this.report_url = appData.reportURL;
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    const attribute_cache = { ...this.cache };
    let targetWebsites = attribute_cache.targetWebSiteDetails;
    if (targetWebsites != null && targetWebsites != "undefined") {
      targetWebsites.map((list) => {
        this.state.targetWebsites.push(list);
      });
    }
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "FabricStyle"
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });
    let patternTypeLookupHandler = new GenericAttributeLookupHandler(
      this.state.patternTypes,
      "Pattern Type"
    );
    this.setState({ patternTypeLookupHandler: patternTypeLookupHandler });
    let productTypeLookupHandler = new GenericAttributeLookupHandler(
      this.state.productTypes,
      "Product Type"
    );
    this.setState({ productTypeLookupHandler: productTypeLookupHandler });
    let productDivisionLookupHandler = new GenericAttributeLookupHandler(
      this.state.productDivisions,
      "Product Division"
    );
    this.setState({
      productDivisionLookupHandler: productDivisionLookupHandler,
    });
  };

  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = this.state.error_list;
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = this.state.success_list;
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  errorCallBack = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error : " + error);
  };
  loadPage = (pageNumber) => {
    this.clearError();
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    let listRequest = new RestFabricStyleListRequest();
    listRequest.searchCriteria = criteria;
    listRequest.pageInput = pageInput;
    this.loadFabricStylePageList(listRequest);
  };

  loadFabricStylePageList = (listRequest) => {
    if (SecurityAccessManager.WebItemExport_IsAccessible()) {
      FabricStyleService.getFabricStylePageList(
        listRequest,
        this.loadFabricStylePageListResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadFabricStylePageListResponse = (response) => {
    const fabricStylePageList = response.data.fabricStylePageList.fabricStyles;
    let fabricStylepageList = response.data.fabricStylePageList;
    let pageList = this.state.pageList;
    pageList.currentPage = fabricStylepageList.currentPage;
    pageList.pageSize = fabricStylepageList.pageSize;
    pageList.totalCount = fabricStylepageList.totalCount;

    if (fabricStylePageList != null) {
      this.setState({
        isFabricStyleDataFound: true,
        fabricStyleDataList: fabricStylePageList,
        pageList: pageList,
        isShowPDFButton: false,
        isShowExcelButton: false,
        // isCriteriaFieldDisabled: true,
        isCollapsible_open: false,
      });
    } else {
      let errMsg = "No data Found";
      let errList = this.state.error_list;
      errList.push(errMsg);
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
      this.setState({
        isFabricStyleDataFound: false,
        isShowPageListToolBar: false,
      });
    }

    this.setState({
      isLoading: false,
    });
  };

  clearError = () => {
    this.setState({ error_list: [] });
  };

  clearCriteria = () => {
    let tempCriteria = new FabricStyleSearchCriteria();
    tempCriteria.companyCode = this.companyCode;
    this.setState({
      criteria: tempCriteria,
      fabricCriteriaList: [],
      isCollapsible_open: true,
      fabricPageListForAutoCompleteList: [],
      isCriteriaFieldDisabled: false,
    });
  };

  reset = () => {
    let tempCriteria = new FabricStyleSearchCriteria();
    tempCriteria.companyCode = this.companyCode;
    this.setState({
      criteria: tempCriteria,
      isFabricStyleDataFound: false,
      fabricStyleDataList: new Array(),
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowSelectAllButton: false,
      isShowUnSelectAllButton: false,
      isShowWebExportButton: false,
      isShowExportAsItemBUutton: false,
      isCollapsible_open: true,
      isShowToolBarButton: true,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      fabricCriteriaList: [],
      fabricPageListForAutoCompleteList: [],
      isCriteriaFieldDisabled: false,
    });
  };

  fetch = (e) => {
    if (e.detail === 1) {
      this.setState({
        isLoading: true,
        loadingText: "Executing",
      });
      this.setState({
        isShowSelectAllButton: true,
        isShowUnSelectAllButton: true,
        isShowWebExportButton: true,
        isShowExportAsItemBUutton: true,
        isShowClearCriteriaButton: false,
        isCollapsible_open: false,
        isShowToolBarButton: false,
        isShowResetButton: true,
      });
      this.state.isCriteriaFieldDisabled = true;
      this.loadPage(1);
    }
  };

  loadItems = () => {};

  selectAllWebFab = (e) => {
    if (e.detail === 1) {
      let list = this.state.targetWebsites;
      list.map((line, i) => {
        line.isApplied = true;
      });
      this.setState({ selectedTargetWebsites: list });
    }
  };

  unSelectAllWebFab = (e) => {
    if (e.detail === 1) {
      let list = this.state.targetWebsites;
      list.map((line, i) => {
        line.isApplied = false;
      });
      this.setState({ selectedTargetWebsites: [] });
    }
  };

  loadExcelFabric = (e) => {
    let file = e.target.files[0];
    let fileName = file.name;
    let fileData = new File([file], `${fileName}`, { type: file.type });
    let formData = new FormData();
    formData.append("file", fileData);

    this.setState({
      fileName: fileName,
      isShowProgressBarPopup: true,
      progressLoadingText: "Loading from Excel...",
    });
    if (SecurityAccessManager.WebItemExport_IsAccessible()) {
      FabricStyleService.FabricStyleExcelUpload(
        formData,
        this.fabricStyleExcelUploadResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };

  fabricStyleExcelUploadResponse = (response) => {
    if (response.data != null) {
      if (response.data.success == true) {
        this.getExcelData();
      }
    } else {
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  getExcelData = () => {
    let request = new RestReadRequest();
    request.companyCode = this.companyCode;
    request.code = this.state.fileName;
    if (SecurityAccessManager.WebItemExport_IsAccessible()) {
      ReportService.getFabricCriteriaExportInputFromExcel(
        request,
        this.getFabricExcelResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };

  getFabricExcelResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null) {
      if (response.data.einput != null) {
        let fabricCriteriaList = response.data.einput.lines;
        let fabricCodes = [];

        let fabric = fabricCriteriaList
          .filter(
            (fb, ind) =>
              ind ===
              fabricCriteriaList.findIndex(
                (lc) => lc.fabricStyleCode === fb.fabricStyleCode
              )
          )
          .map((list) => {
            let baseBean = new BaseBean();
            baseBean.code = list.fabricStyleCode;
            fabricCodes.push(baseBean);
          });
        this.setState({
          fabricCriteriaList: fabricCodes,
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };

  onFabricCodeChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.isShowFabricAutoCompleteList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.isShowFabricAutoCompleteList;
    if (isEmpty(fabricStyleCode)) {
      this.state.isShowFabricAutoCompleteList = false;
      let showAutoCompleteList = this.state.isShowFabricAutoCompleteList;
      let tempCriteria = this.state.criteria;
      tempCriteria.fabricStyleCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        criteria: tempCriteria,
        fabricPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  fabricEnterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    this.readandsetFabricStyleDetail(e.target.value);
    this.state.isShowFabricAutoCompleteList = false;
    let showAutoCompleteList = this.state.isShowFabricAutoCompleteList;
    this.setState({
      fabricPageListForAutoCompleteList: new Array(),
      isShowFabricAutoCompleteList: showAutoCompleteList,
    });
  };
  displayAutoCompleteFabricList = (showAutoCompleteList) => {
    this.setState({ isShowFabricAutoCompleteList: showAutoCompleteList });
  };

  readFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    if (SecurityAccessManager.WebItemExport_IsAccessible()) {
      FabricStyleService.getActiveFabricStylesForAutoComplete(
        input,
        this.readByFabricCodeResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  }

  readByFabricCodeResponse = (response) => {
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData.map((fabricStyle) => {
        let simpleItemBean = {
          code: fabricStyle.fabricStyleCode,
          description: fabricStyle.fabricStyleName,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      fabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  readandsetFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL ? "Reading Item" : "Reading Fabric",
    });

    FabricStyleService.readFabricStyle(
      input,
      this.readandsetFabricStyleDetailResponse,
      this.errorCallBack
    );
  };

  readandsetFabricStyleDetailResponse = (response) => {
    let fabricStyle = response.data.fabricStyle;
    if (fabricStyle != null) {
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = fabricStyle.code;
      this.setState({ fabricStyleData: fabricStyle, criteria: criteria });
    }
    this.setState({ isShowProgressBarPopup: false, progressLoadingText: "" });
  };
  productTypeCodeOnChange = (e) => {
    let productTypeCode = e.target.value;
    this.state.showAutoCompleteProductTypeList = true;

    let temp_criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteProductTypeList;

    if (isEmpty(productTypeCode)) {
      this.state.showAutoCompleteProductTypeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteProductTypeList;
      let criteria = this.state.criteria;
      criteria.productTypeCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteProductTypeList: showAutoCompleteList,
        criteria: criteria,
        showAutoCompleteSalesPersonList: suggestion,
      });
    } else if (showAutoCompleteList === true && productTypeCode !== "") {
      this.readProductTypeBySearchString(productTypeCode);
    }
    temp_criteria[e.target.name] = e.target.value;
    this.setState({ criteria: temp_criteria });

    this.readProductType(productTypeCode);
  };

  readProductType = (productTypeCode) => {
    let productTypeBean = null;
    this.state.productTypes.map((ln) => {
      if (ln.code === productTypeCode) {
        productTypeBean = ln;
      }
    });

    if (!isEmpty(productTypeBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.productTypeCode = productTypeBean.code;
      this.state.showAutoCompleteProductTypeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteProductTypeList;
      this.setState({
        criteria: temp_criteria,
        showAutoCompleteList: showAutoCompleteList,
      });
    }
  };

  readProductTypeBySearchString = (searchString) => {
    let productTypeData = this.state.productTypes;
    let simpleAutoCompleteList = new Array();
    if (productTypeData.length > 0 && productTypeData != null) {
      productTypeData.map((sp) => {
        let productTypeBean = {
          code: sp.code,
          description: sp.description,
        };
        simpleAutoCompleteList.push(productTypeBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      productTypePageListForAutoCompleteList: filteredSuggestions,
    });
  };

  ProductTypeEnterKeyEventHandler = (e) => {
    let productTypeCode = e.target.value;
    this.readProductType(productTypeCode);
    this.setState({
      productTypePageListForAutoCompleteList: new Array(),
    });
  };

  displayAutoCompleteProductList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteProductTypeList: showAutoCompleteList });
  };
  productDivisionCodeOnChange = (e) => {
    let divisionCode = e.target.value;
    this.state.showAutoCompleteProductDivisionList = true;
    let temp_criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteProductDivisionList;
    if (isEmpty(divisionCode)) {
      this.state.showAutoCompleteProductDivisionList = false;
      let showAutoCompleteList = this.state.showAutoCompleteProductDivisionList;
      let criteria = this.state.criteria;
      criteria.divisionCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteProductDivisionList: showAutoCompleteList,
        criteria: criteria,
        showAutoCompleteSalesPersonList: suggestion,
      });
    } else if (showAutoCompleteList === true && divisionCode !== "") {
      this.readProductDivisionBySearchString(divisionCode);
    }
    temp_criteria[e.target.name] = e.target.value;
    this.setState({ criteria: temp_criteria });

    this.readDivision(divisionCode);
  };

  readDivision = (divisionCode) => {
    let productDivisionBean = null;
    this.state.productDivisions.map((ln) => {
      if (ln.code === divisionCode) {
        productDivisionBean = ln;
      }
    });
    if (!isEmpty(productDivisionBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.divisionCode = productDivisionBean.code;
      this.state.showAutoCompleteProductDivisionList = false;
      let showAutoCompleteList = this.state.showAutoCompleteProductDivisionList;
      this.setState({
        criteria: temp_criteria,
        showAutoCompleteList: showAutoCompleteList,
      });
    }
  };
  readProductDivisionBySearchString = (searchString) => {
    let productDivisionData = this.state.productDivisions;
    let simpleAutoCompleteList = new Array();
    if (productDivisionData.length > 0 && productDivisionData != null) {
      productDivisionData.map((sp) => {
        let productDivisionBean = {
          code: sp.code,
          description: sp.description,
        };
        simpleAutoCompleteList.push(productDivisionBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      productDivisionPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  ProductDivisionEnterKeyEventHandler = (e) => {
    let divisionCode = e.target.value;
    this.readDivision(divisionCode);
    this.setState({
      productDivisionPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteProductDivisionList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteProductDivisionList: showAutoCompleteList,
    });
  };
  patternTypeCodeOnChange = (e) => {
    let patternTypeCode = e.target.value;
    this.state.showAutoCompletePatternTypeList = true;
    let temp_criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompletePatternTypeList;
    if (isEmpty(patternTypeCode)) {
      this.state.showAutoCompletePatternTypeList = false;
      let showAutoCompleteList = this.state.showAutoCompletePatternTypeList;
      let criteria = this.state.criteria;
      criteria.patternTypeCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompletePatternTypeList: showAutoCompleteList,
        criteria: criteria,
        showAutoCompleteSalesPersonList: suggestion,
      });
    } else if (showAutoCompleteList === true && patternTypeCode !== "") {
      this.readPatternTypeBySearchString(patternTypeCode);
    }
    temp_criteria[e.target.name] = e.target.value;
    this.setState({ criteria: temp_criteria });
    this.readPatternType(patternTypeCode);
  };

  readPatternType = (patternTypeCode) => {
    let patternTypeBean = null;
    this.state.patternTypes.map((ln) => {
      if (ln.code === patternTypeCode) {
        patternTypeBean = ln;
      }
    });

    if (!isEmpty(patternTypeBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.patternTypeCode = patternTypeBean.code;
      this.state.showAutoCompletePatternTypeList = false;
      let showAutoCompleteList = this.state.showAutoCompletePatternTypeList;
      this.setState({
        criteria: temp_criteria,
        showAutoCompleteList: showAutoCompleteList,
      });
    }
  };

  readPatternTypeBySearchString = (searchString) => {
    let patternTypeData = this.state.patternTypes;
    let simpleAutoCompleteList = new Array();
    if (patternTypeData.length > 0 && patternTypeData != null) {
      patternTypeData.map((sp) => {
        let patternTypeBean = {
          code: sp.code,
          description: sp.description,
        };
        simpleAutoCompleteList.push(patternTypeBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      patternTypePageListForAutoCompleteList: filteredSuggestions,
    });
  };
  patternTypeEnterKeyEventHandler = (e) => {
    let patternTypeCode = e.target.value;
    this.readPatternType(patternTypeCode);
    this.setState({
      patternTypePageListForAutoCompleteList: new Array(),
    });
  };

  displayAutoCompletePatternListList = (showAutoCompleteList) => {
    this.setState({ showAutoCompletePatternTypeList: showAutoCompleteList });
  };

  loadFirst = () => {
    this.loadPage(1);
  };

  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };

  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };

  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };

  selectAll = (e) => {
    if (e.detail === 1) {
      let list = this.state.fabricStyleDataList;
      list.map((line, i) => {
        line.isApplied = true;
      });
      this.setState({ selectedRowDataList: list });
    }
  };

  unSelectAll = (e) => {
    if (e.detail === 1) {
      let list = this.state.fabricStyleDataList;
      list.map((line, i) => {
        line.isApplied = false;
      });
      this.setState({ selectedRowDataList: [] });
    }
  };

  onWebSelectedChange = (val, rowData) => {
    if (rowData.isApplied === true) {
      let selectedLine = this.state.selectedTargetWebsites;
      selectedLine.push(rowData);
      this.setState({ selectedTargetWebsites: selectedLine });
    } else {
      let checkLines = this.state.selectedTargetWebsites;
      let selectedLine = [];
      for (let line of checkLines) {
        if (line.isApplied != rowData.isApplied) {
          selectedLine.push(line);
          this.setState({ selectedTargetWebsites: selectedLine });
        } else if (this.state.selectedTargetWebsites.length == 1) {
          //Added Change
          this.setState({ selectedTargetWebsites: [] }); //Added Change
        }
      }
    }
  };

  onSelectedChange = (val, rowData) => {
    if (rowData.isApplied === true) {
      let selectedLine = this.state.selectedRowDataList;
      selectedLine.push(rowData);
      this.setState({ selectedRowDataList: selectedLine });
    } else {
      let checkLines = this.state.selectedRowDataList;
      let selectedLine = [];
      for (let line of checkLines) {
        if (line.isApplied != rowData.isApplied) {
          selectedLine.push(line);
          this.setState({ selectedRowDataList: selectedLine });
        } else if (this.state.selectedRowDataList.length == 1) {
          //Added Change
          this.setState({ selectedRowDataList: [] }); //Added Change
        }
      }
    }
  };
  exportAsItem = (e) => {
    if (e.detail === 1) {
      let criteria = new FabricStyleWebExportInputBean();
      criteria.companyCode = this.companyCode;
      criteria.items = this.state.selectedRowDataList;
      if (!isEmptyArray(criteria.items)) {
        if (SecurityAccessManager.WebItemExport_IsAccessible()) {
          ReportService.generateMutilWebFabricDataExportData(
            criteria,
            this.generateMutilWebFabricExportDataResponse,
            this.errorCallBack
          );
        } else {
          this.inValidAccess(1);
        }
      } else {
        let errMsg = "";
        if (!this.state.is3PL) {
          errMsg = "No Fabrics Selected";
        } else {
          errMsg = "No Items Selected";
        }
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  generateMutilWebFabricExportDataResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
  };
  WebExport = (e) => {
    if (e.detail === 1) {
      if (!isEmpty(this.state.selectedRowDataList)) {
        this.setState({
          isShowWebExportPopup: true,
        });
      } else {
        let errMsg = "";
        if (!this.state.is3PL) {
          errMsg = "No Fabrics Selected";
        } else {
          errMsg = "No Items Selected";
        }

        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowWebExportPopup: isShowPopup,
    });
  };

  WebExportContinue = (e) => {
    if (e.detail === 1) {
      this.setState({ isShowWebExportPopup: false });
      let criteria = new FabricStyleWebExportInputBean();
      criteria.companyCode = this.companyCode;
      let selectedTargetWebsites = this.state.selectedTargetWebsites;
      let emptyArray = [];
      selectedTargetWebsites.map((list) => {
        let emptyString = list.code + "-" + list.webExportTypCode;
        emptyArray.push(emptyString);
      });
      criteria.exportTypes = emptyArray;
      let selectedRowDataList = this.state.selectedRowDataList;

      let ItemCodes = this.state.ItemCodes;
      selectedRowDataList.map((list) => {
        let SimpleItemBean = new RestSimpleItemBeanRequest();
        SimpleItemBean.code = list.code;
        SimpleItemBean.description = list.description;
        ItemCodes.push(SimpleItemBean);
      });
      criteria.items = ItemCodes;
      criteria.itemListCount = ItemCodes.length;
      if (SecurityAccessManager.WebItemExport_IsAccessible()) {
        ECommerceConnectorService.uploadFabricStylesToEcomConnectorJob(
          criteria,
          this.uploadFabricStylesToEcomConnectorJobResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(1);
      }
    }
  };
  uploadFabricStylesToEcomConnectorJobResponse = (response) => {
    this.handleresponse(response.data);
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowFabricStyleModule: isOpen,
      moduleForPopup: [],
    });
  };
  showHideSecondHeader = () => {
    let tempIsCollapsible_open = !this.state.isCollapsible_open;
    this.setState({ isCollapsible_open: tempIsCollapsible_open });
  };
  viewFabricModule = (code, rowData) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowFabricStyleModule: true,
        moduleForPopup: (
          <PopupFabricStyleModule
            fabricStyleCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };

  onChange = (e) => {
    let tempCriteria = this.state.criteria;
    tempCriteria[e.target.name] = e.target.value;
    this.setState({
      criteria: tempCriteria,
    });
  };
  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = this.state.error_list;
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };

  deleteFabricStyle = (line) => {
    let criteria = this.state.criteria;
    let lineData = criteria.fabricStyleCodesList;
    let fabricCriteriaList = this.state.fabricCriteriaList;
    fabricCriteriaList.map((list, index) => {
      if (list.code === line.code) {
        lineData.splice(index, 1);
        fabricCriteriaList.splice(index, 1);
      }
    });
    this.setState({
      criteria: criteria,
      fabricStyleData: new FabricStyleBean(),
    });
  };

  addFabricStyle = () => {
    let criteria = this.state.criteria;
    let fabricCriteriaList = this.state.fabricCriteriaList;
    let fabricStyleData = this.state.fabricStyleData;
    if (fabricStyleData != null) {
      if (!isEmptyArray(fabricCriteriaList) && !isEmpty(fabricStyleData.code)) {
        let exists = fabricCriteriaList.find(
          (p) => p.code === fabricStyleData.code
        );
        if (!exists) {
          fabricCriteriaList.push(fabricStyleData);
          criteria.fabricStyleCode = "";
          criteria.fabricStyleCodesList.push(fabricStyleData.code);
          this.setState({
            criteria: criteria,
            fabricCriteriaList: fabricCriteriaList,
          });
        }
      } else {
        if (!isEmptyString(fabricStyleData.code)) {
          fabricCriteriaList.push(fabricStyleData);
          criteria.fabricStyleCode = "";
          criteria.fabricStyleCodesList.push(fabricStyleData.code);
          this.setState({
            criteria: criteria,
            fabricCriteriaList: fabricCriteriaList,
          });
        }
      }
    }
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  webExportColumnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails("", "isApplied", 0, false, null, false, null, "2em", "8%")
        .setEditableDetails(
          false,
          "",
          null,
          false,
          null,
          true,
          this.onWebSelectedChange
        )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Website", "code")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Name", "description")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "ExportTypes",
        "webExportTypCode"
      )
    );
    return columnList;
  };
  columnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails("", "isApplied", 0, false, null, false, null, "2em", "8%")
        .setEditableDetails(
          false,
          "",
          null,
          false,
          null,
          true,
          this.onSelectedChange
        )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        this.state.is3PL ? "Item" : "FabricStyle",
        "code",
        0,
        true,
        this.viewFabricModule
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "ProductType",
        "productTypeCode"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Curency", "currencyCode")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Category", "categoryCode")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "SubCategory",
        "subCategoryCode"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Season", "seasonCode")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Default warehouse",
        "defaultLocationCode"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Inv UOM", "inventoryUomCode")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("cost", "cost", 1)
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("retailPrice", "retailPrice", 1)
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Wholesale Price",
        "wholesalePrice",
        1
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("UpdatedDate", "updatedDate")
    );
    return columnList;
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };

  render() {
    let fabricStyleDataList = this.state.fabricStyleDataList;
    let webExportItems = this.state.webExportItems;
    let targetWebsites = this.state.targetWebsites;
    let criteria = this.state.criteria;
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />

        <BaseInquiryToolBar
          {...this.state}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.reset}
          extend_toolbar={
            <>
              {this.state.isShowToolBarButton && (
                <Button
                  className="header_buttons secondary"
                  size="sm"
                  onClick={(e) => this.fetch(e)}
                >
                  Fetch
                </Button>
              )}
            </>
          }
        />
        <CriteriaView
          {...this.state}
          fetch={this.fetch}
          loadExcelFabric={this.loadExcelFabric}
          loadItems={this.loadItems}
          deleteFabricStyle={this.deleteFabricStyle}
          addFabricStyle={this.addFabricStyle}
          onChange={this.onChange}
          showHideSecondHeader={this.showHideSecondHeader}
          onFabricCodeChange={this.onFabricCodeChange}
          fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
          displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
          patternTypeCodeOnChange={this.patternTypeCodeOnChange}
          patternTypeEnterKeyEventHandler={this.patternTypeEnterKeyEventHandler}
          displayAutoCompletePatternListList={
            this.displayAutoCompletePatternListList
          }
          productTypeCodeOnChange={this.productTypeCodeOnChange}
          ProductTypeEnterKeyEventHandler={this.ProductTypeEnterKeyEventHandler}
          displayAutoCompleteProductList={this.displayAutoCompleteProductList}
          productDivisionCodeOnChange={this.productDivisionCodeOnChange}
          ProductDivisionEnterKeyEventHandler={
            this.ProductDivisionEnterKeyEventHandler
          }
          displayAutoCompleteProductDivisionList={
            this.displayAutoCompleteProductDivisionList
          }
        />

        {this.state.isFabricStyleDataFound ? (
          <BaseInquiryPageListToolBar
            {...this.state}
            currentPage={currentPage}
            totalPages={totalPages}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        ) : null}
        {this.state.isFabricStyleDataFound ? (
          <div>
            <Row>
              <Col sm="1">
                <Button
                  id="fabric_Add_Button" //Added Change
                  size="sm"
                  onClick={(e) => this.selectAll(e)}
                >
                  SelectAll
                </Button>
              </Col>
              <Col sm="1">
                <Button
                  id="fabric_Add_Button" //Added Change
                  size="sm"
                  onClick={(e) => this.unSelectAll(e)}
                >
                  UnSelectAll
                </Button>
              </Col>
              <Col sm="1">
                <Button
                  id="fabric_Add_Button" //Added Change
                  size="sm"
                  onClick={(e) => this.exportAsItem(e)}
                >
                  ExportAsItem
                </Button>
              </Col>
              <Col sm="1">
                <Button
                  id="fabric_Add_Button" //Added Change
                  size="sm"
                  onClick={(e) => this.WebExport(e)}
                >
                  WebExport
                </Button>
              </Col>
            </Row>
            <MultiViewPopup
              isModulePopup={false}
              isShowPopup={this.state.isShowWebExportPopup}
              closeOnEsc={false}
              closeAlertModalCallBack={this.closeAlertModalCallBack}
              title={"Multi Export Selection"}
              closeOnDocumentClick={false}
              lineFunctionalityForm={this.lineFunctionalityForm}
              headerButtonContainer={
                <div className="floatLeft">
                  <div>
                    <Button
                      className="header_buttons enterFocus"
                      size="sm"
                      onClick={(e) => this.WebExportContinue(e)}
                    >
                      Continue
                    </Button>
                  </div>
                </div>
              }
              content={
                <div>
                  <Row>
                    <Col sm="1">
                      <Button
                        id="fabric_Add_Button" //Added Change
                        size="sm"
                        onClick={(e) => this.selectAllWebFab(e)}
                      >
                        SelectAll
                      </Button>
                    </Col>
                    <Col sm="1">
                      <Button
                        id="fabric_Add_Button" //Added Change
                        size="sm"
                        onClick={(e) => this.unSelectAllWebFab(e)}
                      >
                        UnSelectAll
                      </Button>
                    </Col>
                  </Row>
                  <Row>
                    <EditableDataGrid
                      columnsList={this.webExportColumnDefinitions()}
                      dataList={targetWebsites}
                    />
                  </Row>
                </div>
              }
            />
            <EditableDataGrid
              columnsList={this.columnDefinitions()}
              dataList={fabricStyleDataList}
            />
          </div>
        ) : null}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowFabricStyleModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}

class CriteriaView extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);

    this.state = {
      criteria: this.props.criteria,
      fabricCriteriaList: this.props.fabricCriteriaList,
      fabricStyleDataList: this.props.fabricStyleDataList,
      isCollapsible_open: this.props.isCollapsible_open,
      patternTypes: this.props.patternTypes,
      productTypes: this.props.productTypes,
      productDivisions: this.props.productDivisions,
      isCriteriaFieldDisabled: this.props.isCriteriaFieldDisabled,
    };
    this.fabricStyleCodeRef = React.createRef();
    this.patternTypeRef = React.createRef();
    this.productTypeRef = React.createRef();
    this.productDivisionRef = React.createRef();
  }

  displayAutoCompleteFabricList = (e) => {
    this.props.displayAutoCompleteFabricList(e);
  };
  fabricEnterKeyEventHandler = (e) => {
    this.props.fabricEnterKeyEventHandler(e);
  };
  deleteFabricStyle = (val, rowData) => {
    this.props.deleteFabricStyle(rowData);
  };
  addFabricStyle = (e) => {
    if (e.detail === 1) {
      this.props.addFabricStyle();
      this.setClear();
    }
  };
  loadExcelFabric = (e) => {
    this.props.loadExcelFabric(e);
  };
  onFabricCodeChange = (e) => {
    this.props.onFabricCodeChange(e);
  };
  onFabricCodeBlur = (e) => {
    this.props.onFabricCodeBlur(e);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  showHideSecondHeader = (e) => {
    if (e.detail === 1) this.props.showHideSecondHeader();
  };
  patternTypeCodeOnChange = (e) => {
    this.props.patternTypeCodeOnChange(e);
  };
  patternTypeEnterKeyEventHandler = (e) => {
    this.props.patternTypeEnterKeyEventHandler(e);
  };
  displayAutoCompletePatternListList = () => {
    this.props.displayAutoCompletePatternListList();
  };
  productTypeCodeOnChange = (e) => {
    this.props.productTypeCodeOnChange(e);
  };
  ProductTypeEnterKeyEventHandler = (e) => {
    this.props.ProductTypeEnterKeyEventHandler(e);
  };
  displayAutoCompleteProductList = () => {
    this.props.displayAutoCompleteProductList();
  };
  productDivisionCodeOnChange = (e) => {
    this.props.productDivisionCodeOnChange(e);
  };
  ProductDivisionEnterKeyEventHandler = (e) => {
    this.props.ProductDivisionEnterKeyEventHandler(e);
  };
  displayAutoCompleteProductDivisionList = () => {
    this.props.displayAutoCompleteProductDivisionList();
  };
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    const { cache } = appData;
    this.cache = cache;
    this.loadCacheDetails();
    this.setFocus();
  }

  setFocus() {
    if (this.fabricStyleCodeRef.current != null) {
      this.fabricStyleCodeRef.current.focus();
    }
  }

  loadCacheDetails = () => {
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    const attribute_cache = { ...this.cache };
    let patternTypes = attribute_cache.patternTypes;
    if (patternTypes != null && patternTypes != "undefined") {
      patternTypes.map((list) => {
        this.props.patternTypes.push(list);
      });
    }
    let productTypes = attribute_cache.productTypes;
    if (productTypes != null && productTypes != "undefined") {
      productTypes.map((list) => {
        this.props.productTypes.push(list);
      });
    }
    let productDivisions = attribute_cache.productDivisions;
    if (productDivisions != null && productDivisions != "undefined") {
      productDivisions.map((list) => {
        this.props.productDivisions.push(list);
      });
    }
  };

  setClear() {
    let criteria = this.state.criteria;
    criteria.fabricStyleCode = "";
    this.setState({ criteria: criteria });
    this.fabricStyleCodeRef.current.clear();
    this.fabricStyleCodeRef.current.focus();
  }

  onExcelFabricClick = (e) => {
    if (e.detail === 1) {
      const input = document.getElementById("file-input");

      if (input) {
        input.click();
      }
    }
  };

  fabricColumnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        this.props.is3PL ? "Item" : "FabricStyle#",
        "code",
        0,
        true
      )
    );
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails(
          "Remove",
          <DeleteIcon />,
          // true,
          1,
          false,
          null,
          false,
          null, //image link call back
          "1em", //min-width
          "20%", //max-width
          false,
          null,
          false
        )
        .setEditableDetails(
          false,
          "",
          null,
          true,
          this.deleteFabricStyle,
          false,
          null
        )
    );
    return columnList;
  };

  render() {
    let criteria = this.props.criteria;
    let fabricCriteriaList = this.props.fabricCriteriaList;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.props.progressLoadingText}
          isShowPopup={this.props.isShowProgressBarPopup}
        />
        <Row className="d-flex justify-content-left">
          <Col sm="1">
            {" "}
            {this.props.is3PL ? (
              <FormLabel>Item</FormLabel>
            ) : (
              <FormLabel>FabricStyle</FormLabel>
            )}
          </Col>
          <Col sm="2">
            <InputTextbox
              ref={this.fabricStyleCodeRef}
              onChange={this.onFabricCodeChange}
              name="fabricStyleCode"
              value={criteria.fabricStyleCode}
              lookupRequired={true}
              lookupHandler={this.props.fabricLookupHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={this.fabricEnterKeyEventHandler}
              autoCompleteListData={
                this.props.fabricPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteFabricList}
              showAutoCompleteList={this.props.isShowFabricAutoCompleteList}
              disabled={this.props.isCriteriaFieldDisabled}
            />
          </Col>
          <Col sm="1">
            {/* {this.props.isShowAddButton && ( */}
            <Button
              id="fabric_Add_Button" //Added Change
              size="sm"
              className="header_buttons enterFocus"
              onClick={(e) => this.addFabricStyle(e)}
              disabled={this.props.isCriteriaFieldDisabled}
            >
              Add
            </Button>
            {/* )} */}
          </Col>

          <Col sm="1">
            <FormLabel>ShortDesc ContainingText</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.onChange}
              name="fabricStyleNameContainingText"
              value={criteria.fabricStyleNameContainingText}
              disabled={this.props.isCriteriaFieldDisabled}
            />
          </Col>
          <Col sm="1">
            {this.props.is3PL ? (
              <FormLabel>Item StartsWith</FormLabel>
            ) : (
              <FormLabel>FabricStyleCode StartsWith</FormLabel>
            )}
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.onChange}
              name="fabricStyleCodeStartsWith"
              value={criteria.fabricStyleCodeStartsWith}
              disabled={this.props.isCriteriaFieldDisabled}
            />
          </Col>
          <Col md={0.9}>
            <CollapseComponent
              isOpen={this.props.isCollapsible_open}
              onClick={(e) => this.showHideSecondHeader(e)}
            />
          </Col>
        </Row>
        {this.props.isCollapsible_open && (
          <Row>
            <Col sm="1">
              {this.props.is3PL ? (
                <FormLabel>Item ContainingText</FormLabel>
              ) : (
                <FormLabel>FabricStyleCode ContainingText</FormLabel>
              )}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onChange}
                name="fabricStyleCodeContainingText"
                value={criteria.fabricStyleCodeContainingText}
                disabled={this.props.isCriteriaFieldDisabled}
              />
            </Col>

            <Col sm="1">
              <FormLabel>ProductType</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.productTypeRef}
                name="productTypeCode"
                onChange={this.productTypeCodeOnChange}
                value={criteria.productTypeCode}
                lookupRequired={true}
                lookupHandler={this.props.productTypeLookupHandler}
                enterKeyEventHandler={this.ProductTypeEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.productTypePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteProductList}
                showAutoCompleteList={
                  this.props.showAutoCompleteProductTypeList
                }
                disabled={this.props.isCriteriaFieldDisabled}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Division</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.productDivisionRef}
                name="divisionCode"
                onChange={this.productDivisionCodeOnChange}
                value={criteria.divisionCode}
                lookupRequired={true}
                lookupHandler={this.props.productDivisionLookupHandler}
                enterKeyEventHandler={this.ProductDivisionEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.productDivisionPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompleteProductDivisionList
                }
                showAutoCompleteList={
                  this.props.showAutoCompleteProductDivisionList
                }
                disabled={this.props.isCriteriaFieldDisabled}
              />
            </Col>
            <Col sm="1">
              <FormLabel>PatternType</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.patternTypeRef}
                name="patternTypeCode"
                onChange={this.patternTypeCodeOnChange}
                value={criteria.patternTypeCode}
                lookupRequired={true}
                lookupHandler={this.props.patternTypeLookupHandler}
                enterKeyEventHandler={this.patternTypeEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.patternTypePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompletePatternListList
                }
                showAutoCompleteList={
                  this.props.showAutoCompletePatternTypeList
                }
                disabled={this.props.isCriteriaFieldDisabled}
              />
            </Col>
          </Row>
        )}
        {this.props.isCollapsible_open && (
          <Row>
            <Col sm="1">
              <FormLabel>Class</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onChange}
                name="classCode"
                value={criteria.classCode}
                disabled={this.props.isCriteriaFieldDisabled}
              />
            </Col>
            <Col sm="1">
              <FormLabel>SubClass</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onChange}
                name="subClassCode"
                value={criteria.subClassCode}
                disabled={this.props.isCriteriaFieldDisabled}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Special</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onChange}
                name="specialCode"
                value={criteria.specialCode}
                disabled={this.props.isCriteriaFieldDisabled}
              />
            </Col>
          </Row>
        )}
        {this.props.isCollapsible_open && (
          <Row>
            <Col sm="4">
              <EditableDataGrid
                columnsList={this.fabricColumnDefinitions()}
                dataList={fabricCriteriaList}
                disabled={this.props.isCriteriaFieldDisabled}
              />
            </Col>
            <Col sm="2">
              <Button
                id="fabric_Add_Button" //Added Change
                size="sm"
                onClick={(e) => this.onExcelFabricClick(e)}
                disabled={this.props.isCriteriaFieldDisabled}
              >
                {this.props.is3PL ? (
                  <FormLabel>Load Excel Item</FormLabel>
                ) : (
                  <FormLabel>LoadExcelFAbric</FormLabel>
                )}
              </Button>
              <input
                type="file"
                id="file-input"
                style={{ display: "none" }}
                onChange={this.loadExcelFabric}
                accept=".doc,.docx,application/pdf,.xlsx, .xls, .csv,.txt"
              />
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

function WebItemExportModule(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <WebItemExport {...props} name="" /> <br />
    </div>
  );
}

export default WebItemExportModule;
